import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'psf-promoter-thank-you',
		path: '/p/:slug/promote/thank_you',
		component: loadable(async () => import(/* webpackChunkName: "pages/psf_promoteThankYou" */ './index'), {
			exportName: 'PromoteThankYou',
			fallback: Loading,
		}),
		frame: true,
	},
];
